import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './ImageWithLoader.scss';

const ImageWithLoader = (props) => {
    const { imgUrl, name } = props;
    const [isLoading, setIsLoading] = useState(true);

    const onLoad = () => setIsLoading(false);

    return (
        <div className='ImageWithLoader'>
            {isLoading && (
                <div className='ImageWithLoader__loading'>
                    <FontAwesomeIcon icon={faSpinner} />
                </div>
            )}

            <img
                style={{
                    opacity: isLoading ? 0 : 1
                }}
                onLoad={onLoad}
                src={imgUrl}
                alt={name} />
        </div>

    );
};

ImageWithLoader.propTypes = {
    imgUrl: PropTypes.string,
    name: PropTypes.string
};

export default ImageWithLoader;
